import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye-on",
  "use": "eye-on-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 13\" id=\"eye-on\">\n<style type=\"text/css\">\n\t#eye-on .st0{fill:#FFFFFF;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M15.6,6.6C13.8,4,11.1,2.3,8,2.3S2.2,4,0.4,6.6c-0.2,0.3-0.1,0.8,0.2,1c0.3,0.2,0.8,0.1,1-0.2\n\t\tC3.2,5.2,5.5,3.8,8,3.8s4.8,1.4,6.4,3.7c0.2,0.3,0.7,0.4,1,0.2S15.9,6.9,15.6,6.6z\" />\n\t<circle class=\"st0\" cx=\"8\" cy=\"7\" r=\"3\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol